/**
 * 달의 유형을 위한 열거체
 * 유형은 이번 달, 다음 달, 이전 달을 가짐
 * @enum {number}
 */
export enum MonthType {
    THIS_MONTH,
    PREV_MONTH,
    NEXT_MONTH,
}
